import styled from 'styled-components';
import {FormGroup} from '../../../forms/form-features/form-group/FormGroup';
import {columnAlignment} from '../tableSetup/tableSetup';

export const TableData = styled.td`
    ${FormGroup} {
        margin: 0;
    }
    ${({textAlign}) => columnAlignment(textAlign)};
`;

export const TableBtnCol = styled(TableData)`
    width: 40px;
`;
